module.exports = __webpack_public_path__ + "media/images/faces/face11-a17da1abfd14e75fc1f13adfca35a136.jpg";